import { createQueryHook } from '@hooks/createQueryHook'

// Single bet detail. Component passes { transactionId }; runs only once it's set.
// Returns render-ready { id, stake, payout, multiplier, crashPoint, fairness, ... }.
export const useBetDetails = createQueryHook('betDetails.get')
